import type { FeatureFlag as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';

/** A feature flag in the platform catalog, independent of any account holding it. */
export type FeatureFlag = {
  feature: string;
  displayName: string;
};

export const fromGql = (item: GQLItem): FeatureFlag => take<FeatureFlag>(item, 'feature', 'displayName');
